import { selectFavouritesSummary, selectIsFavourite } from '@noths/polaris-client-user-favourites';
import { createSelector } from '@reduxjs/toolkit';

import { isSuspended } from 'src/utils/inventoryStatus';
import type { ReduxApplicationState } from './combinedReducer';

export const selectProduct = (state: ReduxApplicationState) => state.product;

export const selectProductDeliveryByEvent = (state: ReduxApplicationState) =>
  state.product.deliveryByEvent;

export const selectProductDeliveryOptions = (state: ReduxApplicationState) =>
  state.product.deliveryOptions;

export const selectProductPrice = (state: ReduxApplicationState) => state.product.price;

export const selectProductReviews = (state: ReduxApplicationState) => state.reviews;

export const selectProductPartner = (state: ReduxApplicationState) => state.product.partner;

export const selectPersonalisationOptions = createSelector(
  [selectProduct],
  (product) => product.options,
);

export const selectFavouriteProduct = createSelector(
  [selectFavouritesSummary, selectProduct],
  (favouritesSummary, product) => {
    const isFavourited = selectIsFavourite(favouritesSummary, product.code);

    return { ...product, isFavourited };
  },
);

export const selectAccessibility = (state: ReduxApplicationState) => state.accessibility;
export const selectBasket = (state: ReduxApplicationState) => state.basket;
export const selectUserConfiguration = (state: ReduxApplicationState) => state.userConfiguration;

export const selectFeatureFlags = (state: ReduxApplicationState): Record<string, string> =>
  selectFeatureFlags(state) || {};

export const selectSuspended = createSelector([selectProduct], (product) =>
  isSuspended(product.availability, product.available),
);
